import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* Headings */\n  h1, h2, h3, h4, h5, h6 {\n    font-family: ", ";\n  }\n\n  h1 {\n    ", "\n\n    ", "\n  }\n\n  h2 {\n    ", "\n\n    ", "\n  }\n\n  h3 {\n    ", "\n\n    ", "\n  }\n\n  h4 {\n    ", "\n\n    ", "\n  }\n\n  h5 {\n    ", "\n\n    ", "\n  }\n\n  h6 {\n    ", "\n  }\n\n  /* Text content */\n\n  blockquote {}\n\n  dl {}\n  dt {}\n  dd {}\n\n  figcaption {}\n  figure {}\n\n  hr {}\n\n  ol {\n    margin: ", " 0;\n  }\n\n  ul {\n    margin: ", " 0;\n  }\n\n  li {\n    ", "\n  }\n\n  p {\n    ", "\n\n    + p {\n      ", "\n    }\n  }\n\n  /* Inline text semantics */\n  a {\n    color: ", ";\n    text-decoration: none;\n    transition: color ease-out .15s;\n    line-height: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  abbr {\n    &[title] {\n      text-decoration: dotted underline;\n    }\n  }\n\n  b, strong {}\n\n  cite {}\n\n  code {}\n\n  em, i {}\n\n  kbd {}\n\n  mark {}\n\n  q {}\n\n  s {}\n\n  small {}\n\n  span {}\n\n  sub {}\n\n  sup {}\n\n  time {}\n\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from "styled-components";
import { darken } from 'polished';
var TypographyStyles = createGlobalStyle(_templateObject(), function (props) {
  return props.theme.fontStacks.heading;
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h2, props.theme.verticalRhythm);
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject2(), props.theme.utils.getFontStyle(props.theme.fontSizes.h1, props.theme.verticalRhythm));
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h3, props.theme.verticalRhythm);
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject3(), props.theme.utils.getFontStyle(props.theme.fontSizes.h2, props.theme.verticalRhythm));
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h4, props.theme.verticalRhythm);
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject4(), props.theme.utils.getFontStyle(props.theme.fontSizes.h3, props.theme.verticalRhythm));
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h5, props.theme.verticalRhythm);
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject5(), props.theme.utils.getFontStyle(props.theme.fontSizes.h4, props.theme.verticalRhythm));
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h5, props.theme.verticalRhythm);
}, function (props) {
  return props.theme.media.tablet_portrait_up(_templateObject6(), props.theme.utils.getFontStyle(props.theme.fontSizes.h5, props.theme.verticalRhythm));
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.h6, props.theme.verticalRhythm);
}, function (props) {
  return "".concat(props.theme.verticalRhythm, "rem");
}, function (props) {
  return "".concat(props.theme.verticalRhythm, "rem");
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.p, props.theme.verticalRhythm, true);
}, function (props) {
  return props.theme.utils.getFontStyle(props.theme.fontSizes.p, props.theme.verticalRhythm, true);
}, function (props) {
  if (props.theme.paragraphRhythm === 'indent') {
    return "\n            text-indent: 1em;\n            ".concat(props.theme.utils.getFontStyle(props.theme.fontSizes.p, props.theme.verticalRhythm), "\n          ");
  } else if (props.theme.paragraphRhythm === 'margin') {
    return "\n            ".concat(props.theme.utils.getFontStyle(props.theme.fontSizes.p, props.theme.verticalRhythm), "\n          ");
  } else {
    return props.theme.utils.getFontStyle(props.theme.fontSizes.p, props.theme.verticalRhythm);
  }
}, function (props) {
  return props.theme.linkColor;
}, function (props) {
  return "".concat(props.theme.verticalRhythm, "rem");
}, function (props) {
  return darken(0.3, props.theme.linkColor);
});
export default TypographyStyles;